/**
 * Шаблони речень з назвою сутності (UX-42). Самих слів тут немає: форми приходять з метаданих
 * (`i18n/words.ts`). Запасні шаблони з двокрапкою діють, коли форм не вистачає (ADM-106).
 */
export const words = {
  records: 'записи',
  recordsGen: 'записів',
  create: (accusative: string) => `Створити ${accusative}`,
  createFallback: (nominative: string) => `Створити: ${nominative}`,
  none: (genitivePlural: string) => `Немає ${genitivePlural}`,
  delete: (what: string) => `Видалити ${what}`,
  deleteFallback: (nominative: string, count: string) => `Видалити: ${nominative} (${count})`,
  countFallback: (count: string, nominative: string) => `${count}: ${nominative}`,
} as const;
